module.exports = __webpack_public_path__ + "img/photo-line.feefd724.svg";